import { COLORS } from '@btime/constants'
import React from 'react'

import { Col, Grid } from '../../packages/kiti/components/structure/Grid'
import { Text } from '../presentation/Text'
import Checkbox from '../shapes/Checkbox'
import Link from '../actions/Link'

const CheckboxInput = ({ onChange, value, label, disabled }) => {
  const handleChange = React.useCallback(() => onChange(!value), [value, onChange])

  return (
    <Link onClick={!disabled && !!onChange ? handleChange : () => {}}>
      <Grid gutter={0.3} justify="flex-start" align="center">
        <Col>
          <Checkbox active={value} disabled={disabled} />
        </Col>
        <Text color={disabled ? COLORS.light3 : COLORS.dark2}>{label}</Text>
      </Grid>
    </Link>
  )
}

export default CheckboxInput
